import Market from '@/creditflowresearch/domain/Market/Market';
import Region from '@/creditflowresearch/domain/Region';
import Segment from '@/creditflowresearch/domain/Segment';
import { MarketAbbreviations, MarketName } from '@/creditflowresearch/domain/Market/types/MarketType';
import { CORPORATE_SEGMENTS } from '@/creditflowresearch/domain/Segment/constants';
import { EMERGING_MARKET_ID } from '@/creditflowresearch/domain/Market/constants';

class EmergingMarket extends Market {
  static readonly MARKET_ID: string = EMERGING_MARKET_ID;

  static readonly NAME: MarketName = MarketName.EMERGING_MARKET;

  static readonly ABBREVIATION: MarketAbbreviations = MarketAbbreviations.EMERGING_MARKET;

  isVisible(): boolean {
    return true;
  }

  isBeta(): boolean {
    return false;
  }

  getSegments(): Segment[] {
    return CORPORATE_SEGMENTS.map((type) => Segment.from(type)).filter(
      (segment): segment is Segment => segment !== null,
    );
  }

  protected getRegionIdForMarket(): string | null {
    return Region.LATM_ID;
  }
}

export default EmergingMarket;
